export const message = {
    common: {
        name:"公积金智库",
        networkError: "网络错误，请检查网络！",
        loading: "加载中...",
        loginTimeout: "您长时间未操作，请关闭重新打开！",
        notFound: "抱歉，找不到相关资源！",
        notSupport: "抱歉，无法处理该操作！",
        welcome: "欢迎使用公积金智库的产品",
        loadingFail: "加载失败，请点击重试！",
        optFail: "操作失败！",
        loginBtn: "登   录",
        regbtn: "注   册",
        listNoMore: "没有更多了",
        listError: "请求失败，点击重新加载",
        cancelText: "取消",
        confirmText: "确认"
    },
    title: {
        404: "找不到资源",
        403: "访问受限",
        home: "首页",
        timeout: "登录超时",
        login: "登录",
        entry: "银联国际",
        authCallback: "银联国际",
        cardWallet: "卡包",
        couponWallet: "券包",
        combinedWallet: "卡券包",
        cardlist: "行业卡列表",
        mall: "积分商城",
        bindCallback: "银联国际",
        regCallback: "银联国际",
        detail: "详情",
        bindCard: "绑定会员卡",
        invalidCards: "失效卡",
        memCardDetail: "会员卡详情",
        invalidCoupons: "失效券",
        couponDetail: "优惠券详情",
        storeList: "门店列表",
        timelimit: "秒杀活动",
        commodity: "商品详情",
        clause: "使用条款",
        privacy: "隐私协议"
    }
}